import {
	requests
}from "../../../../api/agent"

export default {
	create        : (params) => requests.post('/ReInfoOrgType/create', params),
	update        : (params) => requests.post('/ReInfoOrgType/update', params),
	delete        : (params) => requests.getWithParams('/ReInfoOrgType/delete', params),
	restore       : (params) => requests.getWithParams('/ReInfoOrgType/restore', params),
	getPaged      : (params) => requests.getWithParams('/ReInfoOrgType/getPaged', params),
	getPagedAudit : (params) => requests.getWithParams('/ReInfoOrgType/getPagedAudit', params),
	getPagedAll   : (params) => requests.getWithParams('/ReInfoOrgType/getPagedAll', params),
	getList       : (params) => requests.getWithParams('/ReInfoOrgType/getList', params)
}